import React, { useEffect, useState } from 'react';
import { KeyRound } from 'lucide-react';
import { api, formatApiError } from '../../lib/api';
import { useT } from '../../context/LanguageContext';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../ui/dialog';

const TotpLoginDialog = ({ challengeId, onCancel, onVerified }) => {
  const { t } = useT();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setCode('');
    setError('');
  }, [challengeId]);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { data } = await api.post('/auth/totp/verify-login', {
        challenge_id: challengeId,
        code,
      });
      onVerified(data);
    } catch (requestError) {
      setError(formatApiError(requestError, t('Koden kunne ikkje verifiserast.')));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={Boolean(challengeId)} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <DialogContent data-testid="totp-login-dialog" className="w-[calc(100vw-2rem)] max-w-md bg-[#0f0a17] border-white/10 text-white rounded-2xl [&>button]:text-white">
        <DialogTitle className="pr-8 text-2xl font-bold">{t('To-trinnsverifisering')}</DialogTitle>
        <DialogDescription className="text-white/60">{t('Skriv inn koden frå authenticator-appen eller ein gjenopprettingskode.')}</DialogDescription>
        <form onSubmit={submit} className="space-y-4">
          <label htmlFor="totp-login-code" className="sr-only">{t('Authenticator-kode')}</label>
          <input
            id="totp-login-code"
            data-testid="totp-login-code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="(?:[0-9]{6}|[A-Fa-f0-9]{12})"
            maxLength={12}
            required
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/[^0-9a-f]/gi, '').slice(0, 12))}
            className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-4 text-center font-mono text-2xl tracking-[0.2em] text-white outline-none focus:border-[#ff2e2e]"
            placeholder="000000"
          />
          {error && <p role="alert" data-testid="totp-login-error" className="text-sm text-red-300">{error}</p>}
          <button type="submit" disabled={busy || (code.length !== 6 && code.length !== 12)} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#ff2e2e] py-3.5 font-bold text-black disabled:opacity-60">
            <KeyRound size={17} /> {busy ? t('Kontrollerer…') : t('Verifiser og logg inn')}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TotpLoginDialog;